import { TfiAngleRight } from "react-icons/tfi";

export const AngleRight = ({ ...rest }) => {
  return <TfiAngleRight {...rest} />;
};
